import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import JobDiscovery from "@/pages/JobDiscovery";
import JobDetail from "@/pages/JobDetail";
import JobCreate from "@/pages/JobCreate";
import MyJobs from "@/pages/MyJobs";
import Chat from "@/pages/Chat";
import Notifications from "@/pages/Notifications";
import Profile from "@/pages/Profile";
import PublicProfile from "@/pages/PublicProfile";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/masuk" element={<Auth mode="login" />} />
            <Route path="/daftar" element={<Auth mode="register" />} />

            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/app" element={<Dashboard />} />
              <Route path="/cari" element={<JobDiscovery />} />
              <Route path="/pekerjaan/:id" element={<JobDetail />} />
              <Route path="/buat" element={<JobCreate />} />
              <Route path="/pekerjaan-saya" element={<MyJobs />} />
              <Route path="/pesan" element={<Chat />} />
              <Route path="/pesan/:jobId" element={<Chat />} />
              <Route path="/notifikasi" element={<Notifications />} />
              <Route path="/profil" element={<Profile />} />
              <Route path="/pengguna/:id" element={<PublicProfile />} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
